import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ExitIcon from '../../Image/ExitIcon.png';

export default function TPWorkshopEventSelectModal(props) {
  const { data, setSelectedEvent, closeFn } = props;

  const { t } = useTranslation();

  const [pointY, setPointY] = useState(undefined);
  const [nowIndex, setNowIndex] = useState(-1); 

  const TopLevelRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      TopLevelRef.current.style.marginTop = `0px`;
    }, 100)
  }, [TopLevelRef])

  // Modal 창 스크롤 제어 //
  useEffect(() => {
    document.body.style.cssText = `position: fixed; top: -${window.scrollY}px; width: 100%;`

    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = `position: ""; top: "";`
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }, [])

  // useEffect(() => {
  //   console.log(data);
  // }, [data])

  // PC일경우 마우스 클릭 감지 //
  function onMouseDown(e) {
    if (pointY !== undefined) return;

    setPointY(e.screenY);
    TopLevelRef.current.style.transition = 'none';
  }

  // PC일경우 마우스 움직임 감지 //
  function onMouseMove(e) {
    if (pointY === undefined) return;

    if (e.screenY - pointY > 0) TopLevelRef.current.style.marginTop = (e.screenY - pointY) + 'px';
  }

  // PC일경우 마우스 클릭 마무리 감지 //
  function onMouseUp(e) {
    TopLevelRef.current.style.transition = 'all 0.5s ease-in-out';

    if (e.screenY - pointY > 130) onClickExitButton();
    else {
      TopLevelRef.current.style.marginTop = `0px`;
      setPointY(undefined);
    }
  }

  // 모바일일 경우 터치 감지 //
  function onTouchStart(e) {
    if (pointY !== undefined) return;

    setPointY(e.changedTouches[0].screenY);
    TopLevelRef.current.style.transition = 'none';
  }

  // 모바일일 경우 터치 움직임 감지 //
  function onTouchMove(e) {
    if (pointY === undefined) return;

    if (e.changedTouches[0].screenY - pointY > 0) TopLevelRef.current.style.marginTop = (e.changedTouches[0].screenY - pointY) + 'px';
  }

  // 모바일일 경우 터치 움직임 마무리 감지 //
  function onTouchEnd(e) {
    TopLevelRef.current.style.transition = 'all 0.5s ease-in-out';

    if (e.changedTouches[0].screenY - pointY > 130) {
      onClickExitButton();
    }
    else {
      TopLevelRef.current.style.marginTop = `0px`;
      setPointY(undefined);
    }
  }

  // 선택 버튼 클릭시 //
  function onClickSelectButton() {
    if (nowIndex === -1) {
      alert('종목을 선택해주세요');
      return;
    }

    setSelectedEvent(data.events[nowIndex]);
    onClickExitButton();
  }

  //  닫기 버튼 클릭시 //
  function onClickExitButton() {
    TopLevelRef.current.style.marginTop = `790px`;

    setTimeout(() => {
      closeFn();
    }, 300);
  }

  return (
    <Background>
      <TopLevelWrapper
        ref={TopLevelRef}>
        <TitleLineWrapper
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}>
          <TitleWrapper>
            <TitleMaximumWrapper>
              <HoverText fontFamily='NotoSansKR-Black' fontSize={18} color='#4F4F4F'>{t('종목 선택')}</HoverText>
            </TitleMaximumWrapper>
            <Image src={ExitIcon} onClick={onClickExitButton}/>
          </TitleWrapper>
        </TitleLineWrapper>
        <EventBoxWrapper>
        {
          data.events.map((eventData, index) => (
            <EventBox 
              style={{ marginTop: '18px' }} 
              key={index} 
              isClicked={index === nowIndex}
              onClick={() => setNowIndex(index)}>
              {/* <HoverText fontFamily='NotoSansKR-Medium' fontSize={18} color='#4F4F4F'>{data.title + ' ' + eventData.eventTitle}</HoverText> */}
              <HoverText style={{ marginLeft: '14px' }} fontFamily='NotoSansKR-Medium' fontSize={18} color={index === nowIndex ? `#FFFFFF` : '#4F4F4F'}>{eventData.eventTitle}</HoverText>
            </EventBox>
          ))
        }
        </EventBoxWrapper>
        <SelectButton onClick={onClickSelectButton}>
          <HoverText fontFamily='NotoSansKR-Bold' fontSize={18} color='#FFFFFF'>{t('선택')}</HoverText>
        </SelectButton>
      </TopLevelWrapper>
    </Background>
  )
}

const Background = styled.div`
  position: fixed;
	display: flex;
	flex-direction: column;

  justify-content: flex-end;
  align-items: center;

  top: 0;
  left: 0;

  z-index: 500;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
`;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 790px;
  // margin-top: 326px;

	width: 100%;
	// height: 88.16%;
  // height: 55%;
  height: 45%;
  
	border-radius: 28px 28px 0px 0px;
  background-color: #FFFFFF;

  overflow: hidden;

  transition: all 0.5s ease-in-out;
`;

const TitleLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 56px;

  background-color: #FFFFFF;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 90.33%;
`;

const TitleMaximumWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  max-width: 83.68%;
  height: 25px;

  overflow: hidden;
`;

const Image = styled.img`
  width: 20px;
  height: 20px;
`;

const EventBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  // margin-top: 16px;

  width: 100%;

  // background-color: red;
`;

const EventBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: calc(90.33% - 4px);
  height: 47px;

  border: ${props => props.isClicked ? '2px solid #6DD49E' : '2px solid #DFDFDF'};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#FFFFFF`};

  transition: all 0.3s ease-in-out;
`;

const SelectButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 34px;
  // margin-top: 12px;

  width: 90.33%;
  height: 60px;

  border-radius: 12px;
  background-color: #6DD49E;
`;

const HoverText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  padding: 0 0 0 0;
  margin: 0 0 0 0;
  
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;